//文字コードはutf-8

import { initCommonFunctions } from './modules/common.js';
import { initHeaderFunctions } from './modules/header.js';
import { initTopFunctions } from './modules/top.js';
import { initProductFunctions } from './modules/product.js';
import { initRdFunctions } from './modules/rd.js';
import { initBreadCrumb } from './modules/breadCrumb.js';

initCommonFunctions();
initHeaderFunctions();
initTopFunctions();
initProductFunctions();
initRdFunctions();
initBreadCrumb();
